import BaseController from 'controllers/base/controller';
import MenuController from 'controllers/menu-controller';
import PageController from 'controllers/page-controller';
import ReloadControler from 'controllers/reload-controller';

export default { BaseController, MenuController, PageController, ReloadControler };
